

export default class ProductSearch {
    constructor(commodityId, regionId, methodId, styleId, labelId, sizeId){
        this.commodityId = commodityId || "";
        this.regionId = regionId || "";
        this.methodId = methodId || "";
        this.styleId = styleId || "";
        this.labelId = labelId || "";
        this.sizeId = sizeId || "";

        this.isValid = this.isValid.bind(this);
    }

    isValid(){
        if (this.isPropEmpty(this.commodityId)) return false;
        if (this.isPropEmpty(this.regionId)) return false;
        if (this.isPropEmpty(this.methodId)) return false;
        if (this.isPropEmpty(this.styleId)) return false;
        if (this.isPropEmpty(this.labelId)) return false;
        if (this.isPropEmpty(this.sizeId)) return false;
        return true;
    }

    isPropEmpty(prop){
        return (!prop || prop==="" || prop==="undefined");
    }
}